import API from "../../api/apiUser";

export const UserDashboardService = {
    /**
     * Fetch all orders for the authenticated user
     */
    getUserOrders: async () => {
        try {
            const response = await API.get("/user/dashboard/orders");
            return response.data;
        } catch (error) {
            console.error("Failed to fetch user orders:", error);
            throw error;
        }
    },

    /**
     * Fetch recent orders for the dashboard
     */
    getRecentOrders: async () => {
        try {
            const response = await API.get("/user/dashboard/orders/recent");
            return response.data;
        } catch (error) {
            console.error("Failed to fetch recent orders:", error);
            throw error;
        }
    },

    /**
     * Fetch details for a specific order
     * @param {string} orderId 
     */
    getOrderDetails: async (orderId) => {
        try {
            const response = await API.get(`/user/dashboard/orders/${orderId}`);
            return response.data;
        } catch (error) {
            console.error(`Failed to fetch order details for ${orderId}:`, error);
            throw error;
        }
    },
    downloadOrderItem: async (itemId, quality = "original", mediaType = null) => {
        try {
            const params = { quality };
            if (mediaType) params.media_type = mediaType;
            const response = await API.get(`/user/dashboard/orders/download/${itemId}`, {
                params,
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            console.error(`Failed to download item ${itemId}:`, error);
            throw error;
        }
    },
    changePassword: async (data) => {
        try {
            const response = await API.post("/user/dashboard/password/change", data);
            return response.data;
        } catch (error) {
            console.error("Failed to change password:", error);
            throw error;
        }
    }
};
